import { createI18n } from '@learnforge/i18n';
import { locales, type TrigKey } from './locales';

export type { TrigKey } from './locales';

export const i18n = createI18n<TrigKey>({
  gameId: 'trigonometry',
  locales,
});
